<template>
    <div :style="view === 'image' ? 'width: 300px; margin-right: 15px' : 'margin-bottom: 5px'">
        <v-card v-if="view && view === 'image' && !sample" style="position: relative" width="360" height="260"
            class="mr-2 d-flex align-center mb-2">
            <v-progress-circular v-if="loading" indeterminate></v-progress-circular>
            <v-img v-if="!loading && item.url" :src="item.url" width="100%" max-height="260"
                position="center center"></v-img>
            <v-btn icon x-mall color="red" elevation="0" @click="$emit('remove-item', index)"
                style="position: absolute; z-index: 3; top: 5px; right: 5px">
                <v-icon small>mdi-trash-can-outline</v-icon>
            </v-btn>
        </v-card>

        <v-card outlined class="mb-2" v-if="!sample && (!view || view !== 'image')">
            <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
            <v-progress-linear class="mb-n1" color="green" value="100" v-else></v-progress-linear>

            <div :class="`d-flex pa-3 align-center justify-space-between ${loading ? 'mt-n1' : ''}`">
                <div style="flex: 0 0 30px">
                    <v-progress-circular transition="fade-transition" color="primary" indeterminate size="20"
                        v-if="loading"></v-progress-circular>
                    <v-icon transition="fade-transition" v-if="!completed && !loading">
                        {{ icon }}
                    </v-icon>
                    <v-icon transition="fade-transition" color="green" v-if="completed && !loading">
                        mdi-check-bold
                    </v-icon>
                </div>

                <div style="flex: 1 1 50%; font-size: 12px">
                    <a :href="item.url" target="_blank">{{ item.name }}</a>
                </div>

                <div style="flex: 0 0 180px; font-size: 12px" class="pl-3">
                    <v-switch v-if="type === 'nf'" v-model="localCustomerInvoice"
                        :label="localCustomerInvoice ? 'NF TMT' : 'NF NEOOHAds'"></v-switch>
                </div>

                <div style="flex: 0 0 50px; font-size: 12px" class="pl-3">
                    <v-btn icon x-mall color="red" elevation="0" @click="$emit('remove-item', index)">
                        <v-icon small>mdi-trash-can-outline</v-icon>
                    </v-btn>
                </div>
            </div>
        </v-card>

        <v-snackbar v-model="snackbar" color="error" timeout="4000" top centered>
            Arquivo não suportado. O arquivo foi removido.
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                    Fechar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
export default {
    name: 'FileUploadItem',
    props: {
        view: String,
        item: Object,
        index: Number,
        target: String,
        sample: {
            required: false,
            type: Boolean
        },
        type: String
    },
    data() {
        return {
            localCustomerInvoice: this.item.customerInvoice || false,
            loading: true,
            completed: false,
            processing: false,
            snackbar: false
        }
    },
    mounted() {
        this.upload()
    },
    computed: {
        icon() {
            if (this.item.type && this.item.type.includes('image')) {
                return 'mdi-file-image'
            }
            if (this.item.type && this.item.type.includes('.sheet')) {
                return 'mdi-file-excel'
            }
            if (this.item.type && this.item.type.includes('.document')) {
                return 'mdi-file-word'
            }
            return 'mdi-file-document'
        }
    },
    watch: {
        completed(v) {
            if (v) {
                setTimeout(() => {
                    this.completed = false
                }, 200)
            }
        },
        localCustomerInvoice(newVal) {
            const updated = {
                ...this.item,
                customerInvoice: newVal
            }
            this.$emit("set-upload", updated)
        }

    },
    methods: {
        upload() {
            // Se já existe URL, é arquivo já enviado anteriormente (snap)
            if (this.item.url) {
                this.loading = false
                return
            }

            if (this.item.File) {
                this.$emit('loading-processing', true)
                this.loading = true
                this.processing = true

                const payload = new FormData()
                payload.append('files[]', this.item.File)
                payload.append('dist[]', this.target)
                payload.append('url[]', false)

                this.$axios({
                    method: 'post',
                    url: `documents/upload/any`,
                    data: payload,
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                    .then(response => {
                        let uploaded = response.data.data[0]

                        // Garante que a flag customerInvoice vá junto no objeto salvo
                        if (this.type === 'nf') {
                            uploaded.customerInvoice = !!this.item.customerInvoice
                        }
                        else{
                            console.log('Uploaded', response.data.data[0])
                            uploaded = response.data.data[0]

                        }

                        this.$emit('set-upload', uploaded)
                        this.$emit('loading-processing', false)
                        this.loading = false
                        this.completed = true
                        this.processing = false
                    })
                    .catch(error => {
                        this.processing = false
                        this.loading = false
                        this.$emit('loading-processing', false)
                        this.snackbar = true
                        setTimeout(() => {
                            this.$emit('remove-item', this.index)
                        }, 3000)
                    })
            } else {
                this.$emit('loading-processing', false)
                this.loading = false
            }
        }
    }
}
</script>
